var map = {
	"./autorizacion-para-el-uso-y-tratamiento-de-datos-personales.pdf": "7uXd",
	"./calendario_pagos_RPP_2024.pdf": "5nKF",
	"./calendario_pagos_RPP_2025.pdf": "59Hv",
	"./calendario_pagos_RPP_2026.pdf": "srI1",
	"./calendario_pagos_RRVV_2024.pdf": "gEZh",
	"./calendario_pagos_RRVV_2025.pdf": "d34l",
	"./calendario_pagos_RRVV_2026.pdf": "U3rm",
	"./formatos/formato-solicitud-de-renovacion-de-certificado-de-estudios.pdf": "IK49",
	"./formatos/formato-solicitud-de-renovacion-de-certificado-de-supervivencia.pdf": "QNK4",
	"./formatos/formato-solicitud-pago-de-herencia.pdf": "+cQU",
	"./formatos/formato-solicitud-pago-de-renta-de-sobrevivencia.pdf": "W/NU",
	"./formatos/formato_solicitud_cambio_via_de_pago.pdf": "AJJu",
	"./guias/guia-solicitud-de-alta-baja-de-beneficiario-para-essalud.pdf": "gUiM",
	"./guias/guia-solicitud-de-aviso-de-fallecimiento.pdf": "fsJh",
	"./guias/guia-solicitud-de-cambio-de-via-de-pago.pdf": "cTQw",
	"./guias/guia-solicitud-de-pago-de-herencia.pdf": "n6Sv",
	"./guias/guia-solicitud-de-pensión-de-sobrevivencia.pdf": "4Psj",
	"./guias/guia-solicitud-de-renovacion-certificado-de-estudios.pdf": "eWzp",
	"./guias/guia-solicitud-de-renovacion-certificado-de-supervivencia.pdf": "Gf3h",
	"./guias/guia-solicitud-inclusión-exclusión beneficiario.pdf": "XXuF",
	"./guias/guia-vales-agora.pdf": "BY7u",
	"./solicitud_de_anulación_de_poliza.docx": "xuBo"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eifa";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable ^\.\/.*$
// module id = eifa
// module chunks = 1